/**
 * One-click Eingang status (offen / erledigt) for the table and the Maske header, on the
 * shared StatusDropdown. Not the task-derived "Bearbeitung": a person decides when it is done.
 */

import {
  POSTEINGANG_STATE,
  POSTEINGANG_STATE_LABELS,
  POSTEINGANG_STATE_VALUES,
  type PosteingangState,
} from '@brokly/shared';
import { StatusDropdown } from '../../../components/ui/StatusDropdown';
import type { StatusTone } from '../../../components/ui/StatusDot';
import { useSetEingangStatus } from '../hooks/useEingangStatus';

export const EINGANG_STATUS_TONE: Record<PosteingangState, StatusTone> = {
  [POSTEINGANG_STATE.OFFEN]: 'info',
  [POSTEINGANG_STATE.ERLEDIGT]: 'success',
};

const OPTIONS = POSTEINGANG_STATE_VALUES.map((value) => ({
  value,
  label: POSTEINGANG_STATE_LABELS[value],
}));

export function EingangStatusSelect({
  commId,
  status,
  className,
}: {
  commId: string;
  status: PosteingangState;
  className?: string;
}) {
  const setStatus = useSetEingangStatus();
  return (
    <StatusDropdown<PosteingangState>
      value={status}
      options={OPTIONS}
      onChange={(next) => setStatus.mutateAsync({ commId, status: next })}
      current={{ label: POSTEINGANG_STATE_LABELS[status], tone: EINGANG_STATUS_TONE[status] }}
      ariaLabel="Status des Eingangs"
      className={className}
    />
  );
}
